export default {
  'profileaccounts.accountsmanagement': 'Gestione dei Conti Bancari',
  'profileaccounts.bankname': 'Nome della Banca',
  'profileaccounts.branchname': 'Nome della Sede',
  'profileaccounts.accountno': 'Numero di Conto',
  'profileaccounts.cardno': 'Numero di Carta',
  'profileaccounts.shebano': 'Numero di Sheba',
  'profileaccounts.ismain': 'È un Conto Predefinito',
  'profileaccounts.register': 'Registrati',
  'profileaccounts.delete': 'Elimina',
  'profileaccounts.deleteaccount': 'Elimina Conto Bancario',
  'proprofileaccountsfile.cancel': 'Annulla',
  'profileaccounts.deleteconfirmation':
    'Sei sicuro di eliminare il Conto Bancario ?',
  'profileaccounts.accountadd': 'Conto bancario aggiunto correttamente!',
  'profileaccounts.tryagain': 'Per favore riprova',
  'profileaccounts.enterinfo': "inserisci le informazioni dell'account",
  'profileaccounts.addaccount': 'Bankkonto hinzufügen',
  'profileaccounts.cardno-account': 'Numero di Carta/Conto',
  'profileaccounts.Textaccountsmanage':
    'Puoi registrare l account desiderato tramite il seguente modulo.',
};
